import { h } from "preact";

import IconProps from "./IconProps";

function IconFigmaColor({ width, height, class: cssClass }: Omit<IconProps, "color">) {
    return (
        <svg
            width={width}
            height={height}
            class={cssClass}
            fill="none"
            viewBox="0 0 36 52">
            <g clip-path="url(#clip0)">
                <path fill="#0ACF83" d="M9.251 52C14.081 52 18 48.117 18 43.333v-8.668H9.251c-4.829 0-8.749 3.884-8.749 8.668C.502 48.117 4.422 52 9.251 52z"/>
                <path fill="#A259FF" d="M.504 26c0-4.784 3.92-8.668 8.75-8.668h8.748v17.333H9.251C4.422 34.667.504 30.784.504 26z"/>
                <path fill="#F24E1E" d="M.506 8.667C.506 3.883 4.424 0 9.253 0H18v17.333H9.254c-4.83 0-8.747-3.882-8.747-8.666z"/>
                <path fill="#FF7262" d="M18 0h8.749c4.829 0 8.749 3.883 8.749 8.667s-3.92 8.668-8.75 8.668H18V0z"/>
                <path fill="#1ABCFE" d="M35.496 26c0 4.784-3.92 8.667-8.75 8.667C21.919 34.667 18 30.784 18 26s3.92-8.668 8.749-8.668c4.829 0 8.747 3.884 8.747 8.668z"/>
            </g>
            <defs>
                <clipPath id="clip0">
                    <path fill="#fff" d="M0 0H35V52H0z" transform="translate(0.5)"/>
                </clipPath>
            </defs>
        </svg>
    );
}

IconFigmaColor.defaultProps = {
    width: 18,
    height: 26
};

export default IconFigmaColor;
